module.exports = __webpack_public_path__ + "static/media/envelope-stamp.50b6df69.svg";